module.exports = __webpack_public_path__ + "static/restaurant-apps-063d8670341f5e9f418fa53f30208425.jpg";